import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icon-about.svg")